import React from "react";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { ButtonType, SingleSignOnMessages } from "../SingleSignOnComponent";
import { dashed } from "../../lib/utils/strings";
import { AnnouncingHeader } from "../AnnouncingHeader/AnnouncingHeader";

interface SingleSignOnProps {
  stepName: VerificationStepsEnum.sso | VerificationStepsEnum.thirdPartyLoop;
  messages: SingleSignOnMessages;
  logo: React.ReactNode;
  cancelSingleSignOn: () => void;
  cancelButtonType?: ButtonType;
}

const SingleSignOnPending = ({
  stepName,
  messages,
  logo,
  cancelSingleSignOn,
  cancelButtonType = ButtonType.PRIMARY,
}: SingleSignOnProps) => {
  const dashedStepName = dashed(stepName);
  return (
    <div className="sid-header sid-l-horz-center">
      <div className="sid-pending-logo-container sid-l-horz-center">{logo}</div>
      <AnnouncingHeader align="center">{messages.title}</AnnouncingHeader>
      <div className="sid-header__subtitle-one">{messages.subtitle}</div>
      {messages?.subtitle2 && <div className="sid-l-space-top-xl" />}
      <div className="sid-header__subtitle-two sid-h-small-text sid-l-space-top-md">
        {messages?.subtitle2 && messages.subtitle2}
        <div
          className={`sid-form-region sid-${dashedStepName}-pending-submit sid-submit-wrapper sid-l-space-top-md`}
        >
          <button
            onClick={cancelSingleSignOn}
            type="submit"
            className={`sid-btn sid-${dashedStepName}-pending-submit-btn ${
              cancelButtonType === ButtonType.SECONDARY ? "sid-btn-light" : "sid-btn--dark"
            } sid-l-full-width`}
            aria-label="submit"
          >
            {messages.cancel}
          </button>
        </div>
      </div>
      {messages?.subtitle2 ? (
        <div className="sid-l-space-top-xl" />
      ) : (
        <div className="sid-l-space-top-lg" />
      )}
    </div>
  );
};

export const SingleSignOnPendingComponent = SingleSignOnPending;
